module.exports = __webpack_public_path__ + "img/book-closed.d698a2b6.svg";